<div class="FondoLogin" style="min-height: 799px">
    <div class="container" ng-controller="LoginController">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <form name="form-login">
            <div class="ContentLogin"> 
             
              <!--Campos Login-->
              <div class="col-md-12 col-sm-12 col-xs-12 CamposLogin">
                <div class="col-md-12 col-sm-12 col-xs-12 ContentLogo">
                  <img src="../../assets/images/LogoAplicativo.webp" alt="Logo">
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <input type="text" name="username" placeholder="Empresa *" [(ngModel)]="nombreEmpresa" required>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <input type="text" name="direccion" placeholder="Direccion" [(ngModel)]="direccion" required>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <input type="text" name="telefono" placeholder="Telefono de contacto *" [(ngModel)]="telefono" required>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <input type="email" name="email" placeholder="Correo *" [(ngModel)]="email" required>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <input type="password" name="password" placeholder="Contraseña *" [(ngModel)]="password" required>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12">
                <input type="password" name="password" placeholder="Confirme Contraseña *" [(ngModel)]="password1" required>
            </div>

            <!-- <re-captcha (resolved)="resolved($event)" siteKey="6Ld6tfMhAAAAAGBSACLkMcuhA7n8K-jcQ7_R6wmV"></re-captcha> -->

              <div class="col-md-12 col-sm-12 col-xs-12 BtnIngresoLogin">
                <button type="submit" class="button BtnIniciar " (click)="save()">Enviar</button>
              </div>
            </div>
              <!--Fin campos Login-->
            </div>
          </form>
      </div>
    </div>
  </div>
    